export default {
  auth0: {
    setToken: "Auth0/SetToken",
    setUserCode: "Auth0/SetUsercd",
    removeRedis: "Auth0/RemoveToken",
  },
  report: {
    getList: "Report/GetList",
    search: "Report/Search",
    related: "Report/related",
    getTags: "Report/getItemTags",
    getEvaluate: "api/v1/sitecore/contents-delivery-evaluation-button-status",
    evaluate: "api/v1/sitecore/contents-delivery-evaluation-button-status",
  },
  home: {
    search: "Home/Search",
    getbanners: "home/getbanners",
  },
  mypage: { getList: "MyPage/getlist" },
  dictionary: {
    getTagList: "report/gettags",
    getTagFirstList: "report/gettagfirst",
    getTagExampleList: "library/GetTagForLibrary",
    getTagLibraryList: "library/GetLibrarySearchTag",
  },
  image: {
    getByItemId: "report/getimageurl",
    getByKey: "GetMedia/GetMediaData",
  },
  user: {
    getHeaderInfo: "api/v1/sitecore/getCommonHeaderInfo",
    getLoginInfo: "api/v1/sitecore/updateLoginDate",
    logout: "api/v1/sitecore/logout",
    getCompanyInfo: "api/v1/sitecore/getCompanyInfo",
    coreLogout: "api/v1/core/logout",
    coreLogin: "api/v1/core/login",
    getCompanyInfoModificationExistence:
      "api/v1/sitecore/getCompanyInfoModificationExistence",
    getAgreementStatus: "api/v1/terms",
    getBmInfo: "api/v1/business-matching/bm-service-suspension",
    getMenuAuthorityInfo: "api/v1/accounts-authority",
    getUserProfileInfo: "api/v1/common/showUserProfile",
    getAccountMasterExist: "api/v1/accounts/check/master",
    getMenuBadgeInfo: "api/v1/menus/badge",
    getInformationBadgeInfo: "api/v1/news-badge",
    checkUserExist: "api/v1/sitecore/user-existence-check",
    getCustomersVersion: "api/v1/customers-version",
    getContracts: "api/v1/contracts",
  },
  library: {
    getExampleList: "library/GetList",
    getPdfCategory: "library/Getpdfcategory",
    getTrendList: "library/GetTrendList",
    getNriReportList: "library/GetNriReportList",
    getTaxaList: "library/GetTaxaList",
    getIpoList: "library/GetIpoList",
    getIpoYearList: "library/GetIpoYearList",
    getIpoMonthList: "library/GetIpoMonthList",
    getBusinessReportList: "library/GetBusinessReportList",
    getMAList: "library/GetMAList",
    getFinancialList: "library/GetFinancialAnalysisTipsList",
    search: "library/search",
    related: "library/Related",
    pdfLinkAccess: "library/access",
    getTags: "library/getItemTags",
  },
  pickup: {
    getList: "library/pickup",
  },
  faq: {
    getList: "faq/getlist",
  },
  lp: {
    getQAList: "NoLogin/GetFaqList",
    getNewsReleaseList: "NoLogin/GetNewsReleaseList",
  },
  agreement: {
    getNoLoginProtocal: "NoLogin/GetProtocal",
    getLoginProtocal: "Login/GetProtocal",
    getPublishProtocal: "NoLogin/GetPublishProtocal",
    updateLoginProtocal: "Login/UpdateProtocal",
    // 課金-ADD-START
    getLoginPaymentProtocal: "login/getPayUserAgree",
    getLoginUpdatePaymentProtocal: "login/getUpdatePayUserAgree",
    updateLoginPaymentProtocal: "login/UpdatePayUserAgree",
    // 課金-ADD-END
    getNoLoginPrivacyPolicy: "NoLogin/GetServicePolicy",
    getLoginPrivacyPolicy: "Login/GetServicePolicy",
    getPublishPrivacyPolicy: "NoLogin/GetPublishServicePolicy",
    updateLoginPrivacyPolicy: "Login/UpdateServicePolicy",
    getNoLoginInquiry: "NoLogin/GetInquiry",
    getLoginInquiry: "Login/GetInquiry",
    getPublishInquiry: "NoLogin/GetPublishInquiry",
    updateLoginInquiry: "Login/UpdateInquiry",
  },
  common: {
    getTime: "NoLogin/GetTime",
  },
  information: {
    getList: "api/v1/news",
    exist: "api/v1/news/",
    read: "api/v1/news/",
    getDetail: "Notification/GetNotifications",
  },
};
